import axios from 'axios';
import services from '../services/services';
const baseUrl = process.env.BASE_URL || services.baseUrl;
const LoginController = {
    login: async (usuario: string, password: string) => {
        const url = `${baseUrl}${services.loginBase}/${services.loginIniciarSesion}`;
        const params = { usuario, password };
        return axios.get(url, { params }).then((response) => {
            return response;
        }).catch(err => {
            console.log(err);
            return err;
        })
    },

    validarEstados: async (idUsuario: string, idSucursal: string) => {
        const url = `${baseUrl}${services.loginBase}/${services.loginValidarEstados}`;
        const params = { idUsuario, idSucursal };
        try {
            return await axios.get(url, { params })
        } catch (err) {
            console.log(err);
            return err;
        }
    }
}

export default LoginController;